module.exports = __webpack_public_path__ + "img/cheminee.635ba1f.svg";